<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="الإهداء">
<h1><span dir="rtl">الإهداء</span></h1>
<p><span dir="rtl">إلى عائلتي الحبيبة وقُرَّائي الأعزَّاء!</span></p>
<p><span dir="rtl">هذا الكتاب هو تجسيدٌ لروح العطاء والإلهام الذي منحتموني إيَّاهم عبر رحلتي الطويلة في عالم الكتابة.</span></p>
<p><span dir="rtl">إلى عائلتي الغالية.. الداعمة.. قوَّتي وسندي وأملي الدائم!</span> <span dir="rtl">أنتم روح نجاحي ووقود إصراري</span>.</p>
<p><span dir="rtl">وإلى كل قُرَّائي الأعزَّاء الذين أتمنَّى أن يكونوا عنوانًا دائمًا للإلهام والتحفيز!</span></p>
<p><span dir="rtl">أرسل إليكم امتناني العميق على دعمكم المستمر وردود فعلكم القيِّمة على كتابي الأول</span>.</p>
<p><span dir="rtl">أهدي لكم هذا العمل بكلِّ حبٍّ واحترام، عسى أن يكون نقطة تواصُل بين قلوبنا وأفكارنا.</span></p>
<p><span dir="rtl">أتمنَّى أن تجدوا في صفحاته البهجة والسرور</span>.</p>
<p><span dir="rtl">دُمتم في حفظ الله ورعايته.<br/>
</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?57c7739b